import { Component, OnInit, Output, Input, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.css']
})
export class PaginationComponent implements OnInit {

  @Input() totalPageCount: number;
  @Input() startIndex: number;
  @Input() lastIndex: number;
  @Input() totalCount: number;
  @Output() OnAction = new EventEmitter<number>();

  @Input() currentPageNumber: number;
  pagesArray: Array<number> = new Array<number>();

  constructor() {
    this.totalPageCount = 0;
    this.startIndex = 0;
    this.lastIndex = 0;
    this.totalCount = 0;
    this.currentPageNumber = 0;
  }

  ngOnInit() {
    this.CreateRange();
    setTimeout(() => {
      this.ChangePageLiClass();
    }, 50);
  }

  CreateRange() {
    const items: number[] = [];
    let startNumber = 1;
    let endNumber = this.totalPageCount;
    if (this.currentPageNumber >= 0 && this.currentPageNumber <= 5) {
      startNumber = this.currentPageNumber;
    }
    if (this.totalPageCount >= 0 && this.totalPageCount <= 5) {
      endNumber = this.totalPageCount;
    }
    if (this.currentPageNumber >= 3) {
      startNumber = this.currentPageNumber - 2;
      endNumber = this.currentPageNumber + 3;
    }
    if (this.currentPageNumber <= 3) {
      startNumber = this.currentPageNumber - 2;
      endNumber = this.currentPageNumber + 3;
    }
    if (startNumber <= 0) {
      startNumber = this.currentPageNumber;
      endNumber = this.currentPageNumber + 4;
    }
    if (endNumber >= this.totalPageCount) {
      startNumber = this.totalPageCount - 4;
      endNumber = this.totalPageCount;
    }
    if (startNumber <= 0) {
      startNumber = 1;
    }
    for (let i = startNumber; i <= endNumber; i++) {
      items.push(i);
    }
    this.pagesArray = items;
  }

  TriggerAction(_event: any, _pageNumber: number) {
    this.currentPageNumber = _pageNumber;
    this.ChangePageLiClass();
    this.OnAction.emit(this.currentPageNumber);
    this.CreateRange();
  }

  ChangePageNumber(_isNext: boolean) {
    if (_isNext && this.currentPageNumber < this.totalPageCount) {
      this.currentPageNumber++;
      this.ChangePageLiClass();
      this.OnAction.emit(this.currentPageNumber);
    }
    if (!_isNext && this.currentPageNumber > 1) {
      this.currentPageNumber--;
      this.ChangePageLiClass();
      this.OnAction.emit(this.currentPageNumber);
    }
  }

  GoToPage(pageNumber: number) {
    this.currentPageNumber = pageNumber;
    this.CreateRange();
    this.ChangePageLiClass();
    this.OnAction.emit(this.currentPageNumber);
  }

  ChangePageLiClass() {
    [].map.call(document.querySelectorAll('.pageLi'), function (el: any) {
      el.classList.remove('active');
    });
    [].map.call(document.querySelectorAll('#pageLi' + this.currentPageNumber), function (el: any) {
      el.classList.add('active');
    });
  }

}
